import { Lightning, Utils } from "@lightningjs/sdk";
import { Row } from "./Row";
const asset = (name) => Utils.asset(`images/featured/${name}`);
export class FeaturedRow extends Row {
    static _template() {
        const row = super._template();
        const pattern = {
            w: 850,
            h: this.H,
            src: asset("pattern.png"),
        };
        return {
            alpha: row.alpha,
            h: this.H,
            Content: {
                x: -114,
                y: -112,
                w: 1919,
                h: 590,
                // Fade the complete rail so overlapping layers remain opaque to each other.
                renderToTexture: true,
                Background: {
                    y: 112,
                    w: 1919,
                    h: this.H,
                    clipping: true,
                    Fill: { w: 1919, h: this.H, rect: true, color: 0xff9c413e },
                    LeftPattern: Object.assign(Object.assign({}, pattern), { x: 425, y: 239, mount: 0.5, rotation: Math.PI }),
                    RightPattern: Object.assign(Object.assign({}, pattern), { x: 1069 }),
                },
                Cutout: {
                    x: 56,
                    w: 395,
                    h: 590,
                    src: asset("player.png"),
                },
                Title: {
                    x: 459,
                    y: 173,
                    text: {
                        fontFace: "Insatiable Display",
                        fontStyle: "700",
                        fontSize: 59,
                        precision: 1,
                        h: 68,
                        lineHeight: 68,
                        offsetY: 56.1,
                        letterSpacing: -1.18,
                        textColor: 0xffffffff,
                    },
                },
                Subtitle: {
                    x: 879,
                    y: 187,
                    text: {
                        text: "Match Replays",
                        fontFace: "Lato",
                        fontStyle: "400",
                        fontSize: 31,
                        precision: 1,
                        h: 40,
                        lineHeight: 39.7,
                        offsetY: 31,
                        letterSpacing: -0.62,
                        textColor: 0xffdeba37,
                    },
                },
                List: Object.assign(Object.assign({}, row.List), { x: 459, y: 287, w: 1460, h: 245, clipping: true }),
                Logo: {
                    x: 1739,
                    y: 133,
                    w: 62,
                    h: 94,
                    texture: Lightning.Tools.getSvgTexture(asset("logo.svg"), 124, 188),
                },
            },
        };
    }
    set title(title) {
        super.title = title;
        this.tag("List").y = 287;
    }
    createCard(item) {
        var _a;
        return Object.assign(Object.assign({}, super.createCard(item)), { 
            // Ligue 3 games have a 30-second preview before their subscription page.
            preview: "ligue-3", PosterContainer: {
                Lock: {
                    x: 280,
                    y: 12,
                    w: 26,
                    h: 26,
                    visible: (_a = item.locked) !== null && _a !== void 0 ? _a : false,
                    rect: true,
                    color: 0xcc000000,
                    shader: { type: Lightning.shaders.RoundedRectangle, radius: 2 },
                    Icon: {
                        x: 5.3,
                        y: 5,
                        w: 15.4,
                        h: 16,
                        texture: Lightning.Tools.getSvgTexture(asset("lock.svg"), 31, 32),
                    },
                },
            } });
    }
}
FeaturedRow.H = 478;
export default FeaturedRow;
//# sourceMappingURL=FeaturedRow.js.map